module.exports = __webpack_public_path__ + "img/JD-QR.cb474e4c.png";